import omitBy from "lodash/omitBy";

export const generateCartId = (id: number, size: number, color: string) =>
  `${id}-${size}-${color}`;

export const omitByFalsyValue = (object: { [key: string]: any }) => {
  return omitBy(object, (val) => !val);
};
